import React, { useEffect, useRef, useState } from 'react'
import Webcam from 'react-webcam'
import Button from './UI/Button'
import T from './UI/T'
import Title from './UI/Title'
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi'

// gérer mobile / webcam pas dispo (déjà utilisée) / droits pas accordés

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

const imageStyle = { maxWidth: 450, maxHeight: 450, width: '75vw', height: '75vw' }

export default function WebcamCapture({ setPhoto, reset }) {
  const [ratio, setRatio] = useState()
  const [devices, setDevices] = useState()
  const [deviceId, setDeviceId] = useState()
  const [facingMode, setFacingMode] = useState('user')
  const [countdown, setCountdown] = useState(null)
  const [status, setStatus] = useState('auth')
  const webcamRef = useRef(null)

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(mediaDevices =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput"))
    )
  }, [])
  // useEffect(() => {
  //   if (!deviceId && devices)
  //     setDeviceId(devices[0].deviceId)
  // }, [devices])


  const trigger = async () => {
    setCountdown(3)
    await timeout(1000)
    setCountdown(2)
    await timeout(1000)
    setCountdown(1)
    await timeout(1000)
    const image = webcamRef.current.getScreenshot()
    setCountdown(null)
    setPhoto(image)
  }
  
  console.log(devices)
  const switchCamera = () => {
    // const otherCamera = devices.find(d => d.deviceId !== deviceId)
    // setDeviceId(otherCamera.deviceId)
    setFacingMode(facingMode === 'user' ? 'environment' : 'user')
    // setRatio(otherCamera.getSettings().aspectRatio)
  }

  return (
    <div className="flex flex-col justify-center items-center w-full h-screen lg:max-w-5xl mx-auto p-4 lg:p-6 pb-16 lg:pb-32 ">
      <Title><T>preview.title</T></Title>
      <div className="relative overflow-hidden rounded my-5 mx-auto leading-tight lg:max-w-md xl:max-w-md 2xl:max-w-2xl" style={imageStyle}>
        <Webcam
          key={facingMode}
          className="absolute"
          style={{
            width: ratio > 1 ? `${100 * ratio }%`: `100%`,
            height: ratio > 1 ? `100%` : `${100 / ratio }%`,
            // marginLeft: ratio > 1 && `-${(ratio - 1) * 50}%`,
            // marginTop: ratio < 1 && `-${((100 / ratio) - 100) / 2}%`,
            maxWidth: 'none',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          ref={webcamRef}
          onUserMedia={e => {
            setRatio(e.getVideoTracks()[0].getSettings().aspectRatio)
            setStatus('ok')
          }}
          audio={false}
          screenshotFormat="image/jpeg"
          onUserMediaError={e => setStatus({ error: e })}
          // videoConstraints={{ deviceId, width: { min: 720, ideal: 1920 }  }}
          videoConstraints={{ facingMode, width: { min: 720, ideal: 1920, max: 1920 } }}
          forceScreenshotSourceSize
          mirrored={facingMode === 'user'} />
          {status === 'auth' &&
            <div className="w-full h-full flex flex-col justify-center items-center text-base text-center text-secondary">
              You must allow your browser to use your webcam
              <img src="./auth.png" className="hidden lg:block w-64 mt-6 shadow-md rounded" />
              <img src="./authIOS.png" className="lg:hidden w-full mt-6" />
            </div>
          }
          {status?.error &&
            <div className="w-full h-full flex flex-col justify-center items-center text-base text-center text-secondary z-50">
              <strong>An error occurred while trying to access your webcam.</strong>
              <code className="m-4">{`${status.error.message}`}</code>
              <ul className="text-left list-disc text-xs max-w-xl font-thin leading-none">
                <strong>Check the following points:</strong>
                <li>- The webcam is connected</li>
                <li>- The webcam is not already in use</li>
                <li>- You have granted the use of the webcam for this website</li>
              </ul>
            </div>
          }
          {countdown &&
            <div className="absolute w-full h-full flex justify-center items-center text-5xl">
              <div className="w-24 h-24 bg-primary text-secondary rounded-full shadow opacity-75 flex justify-center items-center">{countdown}</div>
            </div>
          }
      </div>
      <div className="fixed top-0 left-0 p-4">
        <Button onClick={reset} Icon={FiArrowLeft} variant="icon"/>
      </div>
      <div className="flex justify-center items-center">
        {devices && devices.length > 1 &&
          <Button style={{ margin: 10 }} onClick={switchCamera} Icon={FiRefreshCw} variant="icon" />
        }
        <Button style={{ margin: 10 }} onClick={trigger} disabled={status !== 'ok'}>Go !</Button>
      </div>
    </div>
  )
}
